(() => {
  const existing = window.SkyTroveShopNavigation;
  if (existing) {
    existing.init(document);
    return;
  }

  const disclosuresWithin = (root) => {
    const disclosures = [];
    if (root instanceof Element && root.matches('.skytrove-nav-disclosure')) disclosures.push(root);
    disclosures.push(...root.querySelectorAll('.skytrove-nav-disclosure'));
    return disclosures;
  };

  const init = (root = document) => {
    disclosuresWithin(root).forEach((disclosure) => {
      if (disclosure.dataset.navReady === 'true') return;
      disclosure.dataset.navReady = 'true';
      const summary = disclosure.querySelector('summary');

      disclosure.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !disclosure.open) return;
        event.preventDefault();
        disclosure.open = false;
        summary?.focus();
      });
      disclosure.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (disclosure.open && !disclosure.contains(document.activeElement)) disclosure.open = false;
        });
      });
    });
  };

  window.SkyTroveShopNavigation = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  init(document);
})();
